import "./modal.css"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import account from "../../../assets/account.png";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";

function AccountModal({show, hideJoinAccModal, onSelectJointType, selectedJointType, appData}) {

    const {t} = useTranslation()

    return (
        <>
            <Modal show={show} onHide={() => hideJoinAccModal()}>
                <Modal.Header>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal_account" onClick={() => onSelectJointType('joint1')}>
                        <img className={`sub_img ${selectedJointType === 'joint1' ? 'selected' : 'hover_sub_img'}`}
                             src={account} alt=""/>
                        <p>{t('modals.ind_modal.joint1')}</p>
                    </div>
                    <div className={appData.citizenship_status === "non_resident" ? "modal_account_disable" : "modal_account"} onClick={() => onSelectJointType('joint2')}>
                        <img className={`sub_img ${selectedJointType === 'joint2' ? 'selected' : 'hover_sub_img'}`}
                             src={account} alt=""/>
                        <p>{t('modals.ind_modal.joint2')}</p>
                    </div>
                    <div className={appData.citizenship_status === "non_resident" ? "modal_account_disable" : "modal_account"} onClick={() => onSelectJointType('joint3')}>
                        <img className={`sub_img ${selectedJointType === 'joint3' ? 'selected' : 'hover_sub_img'}`}
                             src={account} alt=""/>
                        <p>{t('modals.ind_modal.joint3')}</p>
                    </div>
                    <div className={appData.citizenship_status === "non_resident" ? "modal_account_disable" : "modal_account"} onClick={() => onSelectJointType('joint4')}>
                        <img className={`sub_img ${selectedJointType === 'joint4' ? 'selected' : 'hover_sub_img'}`}
                             src={account} alt=""/>
                        <p>{t('modals.ind_modal.joint4')}</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => hideJoinAccModal()}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    appData: state.appData,
});

export default connect(mapStateToProps)(AccountModal);